/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import Container from "./GlobalComponents/Container";
import GeneralSettings from "./GeneralSettings";
import ColorSettings from "./ColorSettings";
import PositioningSettings from "./PositioningSettings";
import Nav from "./Nav";

const Settings = () => {
  const { activeLink } = useContext(PanelsContext);

  return (
    <div css={styles} className="settings">
      <Nav />
      <Container>
        {activeLink === "first" && <GeneralSettings />}
        {activeLink === "second" && <ColorSettings />}
        {activeLink === "third" && <PositioningSettings />}
      </Container>
    </div>
  );
};
const styles = css`
  width: 100%;
  max-width: 700px;
  min-height: 665px;
  .container {
    max-width: 100%;
  }
  @media (max-width: 980px) {
    max-width: 100%;
    min-height: 560px;
  }
  @media (min-width: 981px) and (max-width: 1350px) {
    max-width: 48%;
    nav {
      display: flex;
      justify-content: space-between;
      button {
        width: 32%;
        margin-right: 0;
      }
    }
  }
  @media (max-width: 1350px) {
    nav {
      button {
        display: flex;
        justify-content: center;
      }
    }
  }
`;

export default Settings;
